// This file was auto-generated by Fern from our API Definition.
export const DictOperator = {
    Has: "has",
    HasNot: "has_not",
};
